var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetlify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_444)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_166_444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70V70H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_166_444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4633 29.9545L40.046 1.53727L38.9905 0.483984L37.823 0H32.1781L31.0105 0.483984L29.9551 1.53727L1.53781 29.9545L0.485078 31.01L0 32.1781V37.8219L0.484531 38.9895L1.53727 40.0449L29.9545 68.4622L31.01 69.5155L32.1776 69.9995H37.8224L38.99 69.5155L40.0455 68.4622L68.4627 40.0449L69.516 38.9895L70 37.8219V32.1776L69.516 31.01L68.4633 29.9545Z",
    fill: "#014847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4668 63.4485V49.7968L32.8294 49.4343H37.1732L37.5352 49.7968V63.4485L37.1732 63.8105H32.8288L32.4668 63.4485ZM32.4668 20.2038V6.55215L32.8294 6.18958H37.1732L37.5352 6.55215V20.2038L37.1732 20.5664H32.8288L32.4668 20.2038ZM20.9945 53.3324H20.3962L17.4119 50.3481V49.7498L21.3882 45.7707L24.5481 45.7735L24.9708 46.194V49.3533L20.9945 53.3324ZM17.4119 20.4012V19.8051L20.3962 16.8186H20.9923L24.9708 20.7977V23.9548L24.5502 24.3803H21.391L17.4119 20.4012ZM5.39212 32.4598H20.7462L21.1088 32.8224V37.1711L20.7462 37.5332H5.39212L5.02954 37.1711V32.8224L5.39212 32.4598Z",
    fill: "#32E6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1392 44.0442H38.7981L38.4355 43.6816V33.5207C38.4377 31.7105 37.7279 30.31 35.5436 30.2635C34.4226 30.2345 33.1358 30.2635 31.7642 30.3193L31.5575 30.5309L31.5597 43.6816L31.1971 44.0442H26.856L26.4934 43.6816V26.3183L26.856 25.9563H36.6232C40.4201 25.9563 43.4968 29.033 43.4968 32.8294V43.6816L43.1343 44.0436L43.1392 44.0442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6078 37.5403H49.2537L48.8911 37.1777V32.8289L49.2537 32.4669H64.6078L64.9703 32.8289V37.1777L64.6078 37.5403Z",
    fill: "#32E6E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlify);
export default __webpack_public_path__ + "static/media/netlify.4ba790ca12aea576605cc45d88d8b44c.svg";
export { ForwardRef as ReactComponent };